// src/mockData/disputes.ts

// Helper to create dispute
const createDispute = (
  id: string, 
  customerId: string, 
  assignedTo: string, 
  amount: number, 
  priority: 'critical' | 'high' | 'medium' | 'low'
) => ({
  id,
  customerId,
  assignedTo,
  amount,
  priority,
  status: 'requiring-response' as const,
  reason: ['Quality Issues', 'Billing Discrepancy', 'Service Not Delivered', 'Pricing Dispute'][Math.floor(Math.random() * 4)],
  openedDate: '2026-01-01',
  daysOpen: Math.floor(Math.random() * 20) + 1
});

// Sarah's disputes (4 total, sum to £142,220)
const sarahDisputes = [
  createDispute('DSP-001', 'CUST-001', 'user-001', 47500, 'critical'),
  createDispute('DSP-002', 'CUST-002', 'user-001', 32800, 'high'),
  createDispute('DSP-003', 'CUST-003', 'user-001', 24300, 'high'),
  createDispute('DSP-004', 'CUST-003', 'user-001', 37620, 'medium')
];

// Mike Chen's disputes (9 disputes)
const mikeDisputes = [
  createDispute('DSP-005', 'CUST-006', 'user-002', 52000, 'critical'),
  createDispute('DSP-006', 'CUST-007', 'user-002', 38500, 'high'),
  createDispute('DSP-007', 'CUST-008', 'user-002', 45000, 'high'),
  createDispute('DSP-008', 'CUST-009', 'user-002', 28000, 'medium'),
  createDispute('DSP-009', 'CUST-006', 'user-002', 31000, 'medium'),
  createDispute('DSP-010', 'CUST-007', 'user-002', 22500, 'medium'),
  createDispute('DSP-011', 'CUST-008', 'user-002', 19800, 'low'),
  createDispute('DSP-012', 'CUST-009', 'user-002', 15600, 'low'),
  createDispute('DSP-013', 'CUST-010', 'user-002', 12400, 'low')
];

// Emily Rodriguez's disputes (10 disputes)
const emilyDisputes = [
  createDispute('DSP-014', 'CUST-011', 'user-003', 58000, 'critical'),
  createDispute('DSP-015', 'CUST-012', 'user-003', 62000, 'critical'),
  createDispute('DSP-016', 'CUST-013', 'user-003', 41000, 'high'),
  createDispute('DSP-017', 'CUST-014', 'user-003', 35000, 'high'),
  createDispute('DSP-018', 'CUST-011', 'user-003', 29000, 'medium'),
  createDispute('DSP-019', 'CUST-012', 'user-003', 26500, 'medium'),
  createDispute('DSP-020', 'CUST-013', 'user-003', 23000, 'medium'),
  createDispute('DSP-021', 'CUST-014', 'user-003', 18500, 'low'),
  createDispute('DSP-022', 'CUST-015', 'user-003', 16200, 'low'),
  createDispute('DSP-023', 'CUST-011', 'user-003', 14800, 'low')
];

// David Kim's disputes (9 disputes)
const davidDisputes = [
  createDispute('DSP-024', 'CUST-016', 'user-004', 68000, 'critical'),
  createDispute('DSP-025', 'CUST-017', 'user-004', 54000, 'high'),
  createDispute('DSP-026', 'CUST-018', 'user-004', 46000, 'high'),
  createDispute('DSP-027', 'CUST-019', 'user-004', 38000, 'medium'),
  createDispute('DSP-028', 'CUST-016', 'user-004', 32000, 'medium'),
  createDispute('DSP-029', 'CUST-017', 'user-004', 27500, 'medium'),
  createDispute('DSP-030', 'CUST-018', 'user-004', 21000, 'low'),
  createDispute('DSP-031', 'CUST-019', 'user-004', 17800, 'low'),
  createDispute('DSP-032', 'CUST-020', 'user-004', 15200, 'low')
];

// Lisa Anderson's disputes (13 disputes)
const lisaDisputes = [
  createDispute('DSP-033', 'CUST-021', 'user-005', 78000, 'critical'),
  createDispute('DSP-034', 'CUST-022', 'user-005', 64000, 'critical'),
  createDispute('DSP-035', 'CUST-023', 'user-005', 52000, 'high'),
  createDispute('DSP-036', 'CUST-024', 'user-005', 44000, 'high'),
  createDispute('DSP-037', 'CUST-021', 'user-005', 38000, 'high'),
  createDispute('DSP-038', 'CUST-022', 'user-005', 33000, 'medium'),
  createDispute('DSP-039', 'CUST-023', 'user-005', 29000, 'medium'),
  createDispute('DSP-040', 'CUST-024', 'user-005', 25500, 'medium'),
  createDispute('DSP-041', 'CUST-025', 'user-005', 22000, 'medium'),
  createDispute('DSP-042', 'CUST-021', 'user-005', 19500, 'low'),
  createDispute('DSP-043', 'CUST-022', 'user-005', 17200, 'low'),
  createDispute('DSP-044', 'CUST-023', 'user-005', 15800, 'low'),
  createDispute('DSP-045', 'CUST-024', 'user-005', 13600, 'low')
];

// James Wilson's disputes (13 disputes)
const jamesDisputes = [
  createDispute('DSP-046', 'CUST-026', 'user-006', 86000, 'critical'),
  createDispute('DSP-047', 'CUST-027', 'user-006', 72000, 'critical'),
  createDispute('DSP-048', 'CUST-028', 'user-006', 58000, 'high'),
  createDispute('DSP-049', 'CUST-029', 'user-006', 49000, 'high'),
  createDispute('DSP-050', 'CUST-026', 'user-006', 42000, 'high'),
  createDispute('DSP-051', 'CUST-027', 'user-006', 37000, 'medium'),
  createDispute('DSP-052', 'CUST-028', 'user-006', 32500, 'medium'),
  createDispute('DSP-053', 'CUST-029', 'user-006', 28000, 'medium'),
  createDispute('DSP-054', 'CUST-030', 'user-006', 24500, 'medium'),
  createDispute('DSP-055', 'CUST-026', 'user-006', 21000, 'low'),
  createDispute('DSP-056', 'CUST-027', 'user-006', 18500, 'low'),
  createDispute('DSP-057', 'CUST-028', 'user-006', 16800, 'low'),
  createDispute('DSP-058', 'CUST-029', 'user-006', 14200, 'low')
];

export const DISPUTES = [
  ...sarahDisputes,
  ...mikeDisputes,
  ...emilyDisputes,
  ...davidDisputes,
  ...lisaDisputes,
  ...jamesDisputes
];
